module.exports = __webpack_public_path__ + "static/media/closeEye.58b8b390.svg";